import { useEffect, useState } from "react";
import { MessageCircle, Menu, X } from "lucide-react";
import { LOGO_URL, WHATSAPP_URL } from "@/lib/constants";

const NAV_LINKS = [
  { label: "Início", href: "#top" },
  { label: "Benefícios", href: "#beneficios" },
  { label: "Sobre", href: "#sobre" },
  { label: "FAQ", href: "#faq" },
  { label: "Contato", href: "#contato" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 bg-white transition-all duration-200 ${
        scrolled
          ? "shadow-[0_4px_18px_-10px_rgba(26,43,86,0.18)] border-b border-[var(--buzas-border)]"
          : "border-b border-transparent"
      }`}
    >
      <div className="container-buzas relative flex items-center justify-between h-[72px]">
        {/* Left — Logo */}
        <a
          href="#top"
          data-testid="header-logo"
          className="flex items-center shrink-0"
          style={{ marginLeft: "-4px" }}
        >
          <img
            src={LOGO_URL}
            alt="Buzas Laser Service"
            className="h-9 w-auto object-contain"
            style={{ objectPosition: "left center" }}
          />
        </a>

        {/* Center — Menu */}
        <nav
          data-testid="header-nav"
          className="hidden lg:flex items-center gap-8 absolute left-1/2 -translate-x-1/2"
        >
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={`nav-link-${link.href.replace("#", "")}`}
              className="text-[14px] font-normal text-[#334155] hover:text-[var(--buzas-red)] transition-colors duration-200"
              style={{ letterSpacing: "0.02em" }}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Right — CTA */}
        <div className="hidden md:flex items-center">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="header-whatsapp-cta"
            className="inline-flex items-center gap-2 bg-[var(--buzas-red)] hover:bg-[var(--buzas-red-dark)] text-white text-[14px] font-bold rounded-md transition-all duration-200 hover:-translate-y-px hover:shadow-[0_8px_20px_-8px_rgba(217,54,54,0.55)]"
            style={{ padding: "8px 20px" }}
          >
            <MessageCircle size={14} strokeWidth={2.2} />
            Falar no WhatsApp
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Abrir menu"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-md border border-[var(--buzas-border)] text-[#334155]"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden border-t border-[var(--buzas-border)] bg-white"
        >
          <div className="container-buzas py-5 flex flex-col gap-1">
            {NAV_LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${link.href.replace("#", "")}`}
                className="py-3 text-[15px] font-medium text-[#334155] hover:text-[var(--buzas-red)] border-b border-[var(--buzas-border)]"
              >
                {link.label}
              </a>
            ))}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="mobile-whatsapp-cta"
              className="inline-flex items-center justify-center gap-2 mt-4 w-full bg-[var(--buzas-red)] hover:bg-[var(--buzas-red-dark)] text-white text-[14px] font-bold rounded-md py-2.5"
            >
              <MessageCircle size={14} />
              Falar no WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
